import { render, staticRenderFns } from "./reset_pass.vue?vue&type=template&id=5c4bc798&scoped=true"
import script from "./reset_pass.vue?vue&type=script&lang=js"
export * from "./reset_pass.vue?vue&type=script&lang=js"
import style0 from "./reset_pass.vue?vue&type=style&index=0&id=5c4bc798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bc798",
  null
  
)

export default component.exports